import React, {Fragment} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import filterState from '../../helpers/lgas';
import { setStateFilterSearch, setAreaFilterSearch, setPropertyType,
  setCategoryType, setListingType, setPurchaseOption } from '../../actions/filterSearch';
import  getTouchCount from '../../helpers/pagination';
import {HouseHolds, MoreHouseHolds, RealEstate, SkilledLabour, Pets,} from '../../helpers/DropDowns/ShopAll';

const SearchFilter = () => {
  const dispatch = useDispatch();
  const { localState, localArea, propertyType, 
          categoryType, listingType } = useSelector(state => state.filterSearch);
  const getFilterState = filterState();
  const filterStateLocales = getFilterState.filter(data => data.state === localState);
  const getLocalGovt = filterStateLocales[0].lgas;
  // const { pagCount, maxCount } = useSelector(state => state.pagCount);
 

  const handleChangeState = (e) =>{
    e.preventDefault();
    dispatch(setStateFilterSearch(e.target.value));
  };

  const handleChangeArea = (e) =>{
    e.preventDefault();
    dispatch(setAreaFilterSearch(e.target.value));
  };

  const handleChangePropertyType = (e) =>{
    e.preventDefault();
    dispatch(setPropertyType(e.target.value));
  };

  const handlePurchaseOption = (e) =>{
    e.preventDefault();
    dispatch(setPurchaseOption(e.target.value));
  };

  const handleChangePropertyPrice = (e) =>{
    e.preventDefault();
    dispatch(setPropertyPriceFilterSearch(e.target.value));
  };

  const handleChangeCategoryType = (e) => {
    e.preventDefault();
    dispatch(setCategoryType(e.target.value));
  };

  const handleChangeListing = (e) => {
    e.preventDefault();
    dispatch(setListingType(e.target.value));
  };

  const performSearch = (e) => {
    e.preventDefault();
    const countryState = e.target.countryState.value;
    const propertyArea = e.target.localArea.value;
    const propertyListing = e.target.propertyListing.value;
    const propertyPurchaseOption = e.target.purchaseOption.value;

    //set search filters
    dispatch(setStateFilterSearch(countryState));
    dispatch(setAreaFilterSearch(propertyArea));
    dispatch(setListingType(propertyListing));
    dispatch(setPurchaseOption(propertyPurchaseOption));


  };


 


  return (
    <div className='filter-search-form-div'>
      <form onSubmit={performSearch} className='filter-search-details'>
        <p className='filter-search-header'>Perform Search</p>

        <label className='filter-search-label'>Country</label><br/>
        <select className='filter-search-input' name='country' >
          <option>Nigeria</option>
          <option>United States of America</option>
        </select><br/>
        

        <label className='filter-search-label'>State/County</label><br/>
        <select className='filter-search-input' onChange={handleChangeState} name='countryState'>
          {getFilterState.map(data=> (
            <option key={data.state}>{data.state}</option>
          ))}
        </select><br/>


        <label className='filter-search-label'>Region</label><br/>
        <select className='filter-search-input' onChange={handleChangeArea} name='localArea'>
          {!!getLocalGovt ? (
            getLocalGovt.map(data => (
              <option key={data}>{data}</option>
            ))
          ) : ''}
        </select><br/>


         {/* {!!propertyType && propertyType === 'Real Estate' ? (
           <Fragment>
             <label className='filter-search-label'>Purchase Option</label><br/>
             <select className='filter-search-input' onChange={handlePurchaseOption} name='purchaseOption' >
              <option>Buy</option>
              <option>Rent</option>
              <option>Lease</option>
             </select><br/>
            </Fragment>
         ) : ''} */}

         {<Fragment>
             <label className='filter-search-label'>Purchase Option</label><br/>
             <select className='filter-search-input' 
               onChange={handlePurchaseOption} name='purchaseOption' 
               disabled={(!!propertyType && propertyType === 'Real Estate') === false }>
              <option>Buy</option>
              <option>Rent</option>
              <option>Lease</option>
             </select><br/>
            </Fragment>}


        <label className='filter-search-label'>Type</label><br/>
        <select className='filter-search-input'  onChange={handleChangePropertyType} name='propertyType'>
          <option>Real Estate</option>
          <option>Reservation and Bookings</option>
          <option>Shop and Listings</option>
        </select><br/>

          {!!propertyType && (propertyType === 'Real Estate' || propertyType === 'Reservation and Bookings') ? (
           <Fragment>
             <label className='filter-search-label'>Real Estate</label><br/>
             <select className='filter-search-input'  onChange={handleChangeListing} name='propertyListing' >
               {!!propertyType && propertyType === 'Real Estate' ? 
                 <option>Residential</option> : <option>Apartments</option>}
                 <option>Office Space</option>
                 <option>Commercial Property</option>
             </select><br/>
           </Fragment>
         ) : ''}

         
        {!!propertyType && propertyType === `Shop and Listings` ? (
          <Fragment>
            <label className='filter-search-label'>Categories</label><br/>
            <select className='filter-search-input'  onChange={handleChangeCategoryType} name='PropertyGroup'>
              <option>HouseHolds</option>
              <option>Skilled Craft</option>
              <option>Pets</option>
            </select><br/>
          </Fragment>
        ) : ''}

        {!!propertyType && propertyType === `Shop and Listings` && !!categoryType && 
           categoryType === `HouseHolds` ? (
          <Fragment>
            <label className='filter-search-label'>Households</label><br/>
            <select className='filter-search-input'  onChange={handleChangeListing} name='propertyListing' >
              {HouseHolds.length > 0 ? HouseHolds.concat(MoreHouseHolds).map(data => (
                <option key={data}>
                  {data}
                </option>
              )) : ''}
            
            </select><br />
          </Fragment>
        ) : ''}

        {!!propertyType && propertyType === `Shop and Listings` && !!categoryType &&
          categoryType === 'Skilled Craft' ? (
          <Fragment>
            <label className='filter-search-label'>Skilled Craft</label><br/>
            <select className='filter-search-input'  onChange={handleChangeListing}  name='propertyListing'  >
            {SkilledLabour.length > 0 ? SkilledLabour.map(data => (
                <option key={data}>
                  {data}
                </option>
              )) : ''}
              
            </select><br/>
          </Fragment>
        ) : ''}

           {!!propertyType && propertyType === `Shop and Listings`  && !!categoryType &&
          categoryType === 'Pets'  ? (
          <Fragment>
            <label className='filter-search-label'>Pets</label><br/>
            <select className='filter-search-input'  onChange={handleChangeListing}  name='propertyListing'>
            {Pets.length > 0 ? Pets.map(data => (
                <option key={data}>
                  {data}
                </option>
              )) : ''}
              
            </select><br/>
          </Fragment>
        ) : ''}


         {/* <label className='filter-search-label'>Price Range</label><br/>
          <select className='filter-search-input' onChange={handleChangePropertyPrice}>
            <option> 10,000,000 above</option>
            <option> 10,000,000 below </option>
            <option>100,000,000</option>
          </select><br/> */}

          <button className='filter-search-place-order'>
            {(!!categoryType && categoryType === 'Pets' || categoryType === 'Skilled Craft' ||
              categoryType === 'HouseHolds' || categoryType === 'HouseHolds') && 
              (!!propertyType && propertyType === `Shop and Listings`) ? `Find ${categoryType}` : `Find Property`}
          </button>

      </form>

    </div>
  )
};

export default SearchFilter;